import { OMT_UI_FriendsListView } from '../../../OMT_UI/FriendsList/OMT_UI_FriendsListView';
import { FriendsScoresExpandedUserView, COIN_REQUEST_STATUS } from './FriendsScoresExpandedUserView';

import {
  EXPANDED_LIST_SCROLL_CONFIG,
} from '../../MainLeaderboardSettings';

const RENDER_ITEM_DELAY = 16;

/*
  freinds scores expanded list view
*/
export class FriendsScoresExpanded extends OMT_UI_FriendsListView {
  /**
   * main init function. call manually or from extending Class
   * @param {number} itemHeight
   * @param {Phaser.Rectangle} scrollRect
   * @returns {Promise}
   */
  async init(itemHeight, scrollRect) {
    this.signals.onCoinRequestSuccess = new Phaser.Signal();
    const [EXPANDED_ODD_ROW_COLOR, EXPANDED_EVEN_ROW_COLOR] = this.getAlternatingRowColors();
    await super.init(itemHeight, scrollRect, EXPANDED_ODD_ROW_COLOR, EXPANDED_EVEN_ROW_COLOR, EXPANDED_LIST_SCROLL_CONFIG, RENDER_ITEM_DELAY);
    this._scrollArea.allowOverScroll = true;
    this._scrollArea.addScrollCondition(() => {
      const { windowMgr } = game.state.getCurrentState();
      return windowMgr.isQueueEmpty;
    });
    this.disable();
  }

  /**
   * create the ExpandedUserView
   * @param {Object} friendData
   * @param {number} itemWidth
   * @param {number} itemHeight
   * @param {number} bgColor
   */
  _createFriendListItem(friendData, itemWidth, itemHeight, bgColor) {
    const listItem = new FriendsScoresExpandedUserView(friendData, itemWidth, itemHeight, bgColor);
    listItem.signals.onCoinRequest.add(this._onCoinRequestStatusUpdate, this);
    return listItem;
  }

  /**
   * lock the display while request is in progress
   * @param {FriendsScoresExpandedUserView} userView
   * @param {number} status
   */
  _onCoinRequestStatusUpdate(userView, status) {
    if (status === COIN_REQUEST_STATUS.REQUESTED) {
      this.disable();
    } else if (status === COIN_REQUEST_STATUS.SUCCESS) {
      this.enable();
      this.signals.onCoinRequestSuccess.dispatch(userView);
    } else if (status === COIN_REQUEST_STATUS.FAILED) {
      this.enable();
    }
  }

  /**
   * enable interactivity
   */
  enable() {
    super.enable();
    for (const listItem of this._listItems) listItem.enable();
  }

  /**
   * disable interactivity
   */
  disable() {
    super.disable();
    for (const listItem of this._listItems) listItem.disable();
  }

  /**
   * main update method
   */
  update() {
    if (this._enabled) super.update();
  }
}
